<template>
  <div v-if="!excluded">
    <b-breadcrumb :items="crumbs"></b-breadcrumb>
  </div>
</template>
<script>
  export default {
    name: 'BreadcrumbHistory',
    props: {
      exclude: {type: Array, default: () => []}
    },
    computed: {
      excluded() {
        return this.exclude.indexOf(this.$route.path.split('/').pop()) > -1;
      },
      tree() {
        return ['YOU ARE HERE']
          .concat(this.$route.path
            .split('/')
            .slice(1)
            .map(route => route
              .split('-')
              .map(word => word[0].toUpperCase() + word.slice(1))
              .join(' '),
            )
          );
      },
      crumbs() {
        let pathArray = this.$route.path.split("/")
        pathArray.shift()
        
        //console.log("singgih: "+pathArray)
        let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
          breadcrumbArray.push({
            path: path,
            to: breadcrumbArray[idx - 2]
              ? "/" + breadcrumbArray[idx - 2].path + "/" + breadcrumbArray[idx - 1].path + "/"  + path
              : breadcrumbArray[idx - 1]
              ? "/" + breadcrumbArray[idx - 1].path + "/" + path
              : "/" + path,
            text: path.split('-').join(' ').toUpperCase(),
          });
          return breadcrumbArray;
        }, [])
        return breadcrumbs;
      }
    }
  }
</script>
